//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AbrApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param searchString (optional) 
     * @return OK
     */
    searchUsers(searchString?: string | undefined): Promise<BreachersUser[]> {
        let url_ = this.baseUrl + "/BreachersUser/SearchUsers?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: Response): Promise<BreachersUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreachersUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreachersUser[]>(null as any);
    }

    /**
     * @param breachersUserId (optional) 
     * @return OK
     */
    getUser(breachersUserId?: string | undefined): Promise<BreachersUser> {
        let url_ = this.baseUrl + "/BreachersUser/GetUser?";
        if (breachersUserId === null)
            throw new Error("The parameter 'breachersUserId' cannot be null.");
        else if (breachersUserId !== undefined)
            url_ += "BreachersUserId=" + encodeURIComponent("" + breachersUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<BreachersUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreachersUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreachersUser>(null as any);
    }

    /**
     * @param breachersUserId (optional) 
     * @return OK
     */
    linkDiscordUser(breachersUserId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BreachersUser/LinkDiscordUser?";
        if (breachersUserId === null)
            throw new Error("The parameter 'breachersUserId' cannot be null.");
        else if (breachersUserId !== undefined)
            url_ += "BreachersUserId=" + encodeURIComponent("" + breachersUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkDiscordUser(_response);
        });
    }

    protected processLinkDiscordUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param discordUserId (optional) 
     * @return OK
     */
    getLinkedBreachersUser(discordUserId?: number | undefined): Promise<BreachersUser> {
        let url_ = this.baseUrl + "/BreachersUser/GetLinkedBreachersUser?";
        if (discordUserId === null)
            throw new Error("The parameter 'discordUserId' cannot be null.");
        else if (discordUserId !== undefined)
            url_ += "DiscordUserId=" + encodeURIComponent("" + discordUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkedBreachersUser(_response);
        });
    }

    protected processGetLinkedBreachersUser(response: Response): Promise<BreachersUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreachersUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreachersUser>(null as any);
    }

    /**
     * @return OK
     */
    healthCheck(): Promise<void> {
        let url_ = this.baseUrl + "/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param limit (optional) 
     * @param page (optional) 
     * @return OK
     */
    matchHistory(limit?: number | undefined, page?: number | undefined): Promise<MatchDto[]> {
        let url_ = this.baseUrl + "/MatchStats/MatchHistory?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchHistory(_response);
        });
    }

    protected processMatchHistory(response: Response): Promise<MatchDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDto[]>(null as any);
    }

    /**
     * @param discordUserId (optional) 
     * @param limit (optional) 
     * @param page (optional) 
     * @return OK
     */
    userMatchHistory(discordUserId?: number | undefined, limit?: number | undefined, page?: number | undefined): Promise<MatchDto[]> {
        let url_ = this.baseUrl + "/MatchStats/UserMatchHistory?";
        if (discordUserId === null)
            throw new Error("The parameter 'discordUserId' cannot be null.");
        else if (discordUserId !== undefined)
            url_ += "DiscordUserId=" + encodeURIComponent("" + discordUserId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserMatchHistory(_response);
        });
    }

    protected processUserMatchHistory(response: Response): Promise<MatchDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDto[]>(null as any);
    }

    /**
     * @param matchId (optional) 
     * @return OK
     */
    matchData(matchId?: string | undefined): Promise<MatchDataDto> {
        let url_ = this.baseUrl + "/MatchStats/MatchData?";
        if (matchId === null)
            throw new Error("The parameter 'matchId' cannot be null.");
        else if (matchId !== undefined)
            url_ += "MatchId=" + encodeURIComponent("" + matchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchData(_response);
        });
    }

    protected processMatchData(response: Response): Promise<MatchDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDataDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteUser(body?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Webhook/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BreachersUser implements IBreachersUser {
    id?: string | null;
    userName?: string | null;
    clanTag?: string | null;
    readonly fullUserName?: string | null;

    constructor(data?: IBreachersUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.clanTag = _data["clanTag"] !== undefined ? _data["clanTag"] : <any>null;
            (<any>this).fullUserName = _data["fullUserName"] !== undefined ? _data["fullUserName"] : <any>null;
        }
    }

    static fromJS(data: any): BreachersUser {
        data = typeof data === 'object' ? data : {};
        let result = new BreachersUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["clanTag"] = this.clanTag !== undefined ? this.clanTag : <any>null;
        data["fullUserName"] = this.fullUserName !== undefined ? this.fullUserName : <any>null;
        return data;
    }
}

export interface IBreachersUser {
    id?: string | null;
    userName?: string | null;
    clanTag?: string | null;
    fullUserName?: string | null;
}

export class GadgetData implements IGadgetData {
    type?: GadgetType;
    used?: number;
    triggered?: number;
    enemyTriggered?: number;
    kills?: number;
    damage?: number;
    friendlyDamage?: number;
    destroyed?: number;
    healed?: number;

    constructor(data?: IGadgetData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.used = _data["used"] !== undefined ? _data["used"] : <any>null;
            this.triggered = _data["triggered"] !== undefined ? _data["triggered"] : <any>null;
            this.enemyTriggered = _data["enemyTriggered"] !== undefined ? _data["enemyTriggered"] : <any>null;
            this.kills = _data["kills"] !== undefined ? _data["kills"] : <any>null;
            this.damage = _data["damage"] !== undefined ? _data["damage"] : <any>null;
            this.friendlyDamage = _data["friendlyDamage"] !== undefined ? _data["friendlyDamage"] : <any>null;
            this.destroyed = _data["destroyed"] !== undefined ? _data["destroyed"] : <any>null;
            this.healed = _data["healed"] !== undefined ? _data["healed"] : <any>null;
        }
    }

    static fromJS(data: any): GadgetData {
        data = typeof data === 'object' ? data : {};
        let result = new GadgetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["used"] = this.used !== undefined ? this.used : <any>null;
        data["triggered"] = this.triggered !== undefined ? this.triggered : <any>null;
        data["enemyTriggered"] = this.enemyTriggered !== undefined ? this.enemyTriggered : <any>null;
        data["kills"] = this.kills !== undefined ? this.kills : <any>null;
        data["damage"] = this.damage !== undefined ? this.damage : <any>null;
        data["friendlyDamage"] = this.friendlyDamage !== undefined ? this.friendlyDamage : <any>null;
        data["destroyed"] = this.destroyed !== undefined ? this.destroyed : <any>null;
        data["healed"] = this.healed !== undefined ? this.healed : <any>null;
        return data;
    }
}

export interface IGadgetData {
    type?: GadgetType;
    used?: number;
    triggered?: number;
    enemyTriggered?: number;
    kills?: number;
    damage?: number;
    friendlyDamage?: number;
    destroyed?: number;
    healed?: number;
}

export enum GadgetType {
    FragGrenade = "FragGrenade",
    SmokeGrenade = "SmokeGrenade",
    IncendiaryGrenade = "IncendiaryGrenade",
    HealSyringe = "HealSyringe",
    BreachingFoam = "BreachingFoam",
    Flashbang = "Flashbang",
    CloakingDevice = "CloakingDevice",
    Drone = "Drone",
    Tripwire = "Tripwire",
    StaticFieldEmitter = "StaticFieldEmitter",
    ProximitySensor = "ProximitySensor",
    DoorBlocker = "DoorBlocker",
    Emp = "Emp",
    BreachingFoamForAllTeams = "BreachingFoamForAllTeams",
}

export class GameDataEntity implements IGameDataEntity {
    id?: string;
    domainEvents?: IDomainEvent[] | null;
    matchId?: string;
    score?: MapScore;
    players?: GamePlayerData[] | null;
    readonly homePlayers?: GamePlayerData[] | null;
    readonly awayPlayers?: GamePlayerData[] | null;
    readonly rounds?: GameRoundData[] | null;

    constructor(data?: IGameDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    this.domainEvents!.push(IDomainEvent.fromJS(item));
            }
            else {
                this.domainEvents = <any>null;
            }
            this.matchId = _data["matchId"] !== undefined ? _data["matchId"] : <any>null;
            this.score = _data["score"] ? MapScore.fromJS(_data["score"]) : <any>null;
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(GamePlayerData.fromJS(item));
            }
            else {
                this.players = <any>null;
            }
            if (Array.isArray(_data["homePlayers"])) {
                (<any>this).homePlayers = [] as any;
                for (let item of _data["homePlayers"])
                    (<any>this).homePlayers!.push(GamePlayerData.fromJS(item));
            }
            else {
                (<any>this).homePlayers = <any>null;
            }
            if (Array.isArray(_data["awayPlayers"])) {
                (<any>this).awayPlayers = [] as any;
                for (let item of _data["awayPlayers"])
                    (<any>this).awayPlayers!.push(GamePlayerData.fromJS(item));
            }
            else {
                (<any>this).awayPlayers = <any>null;
            }
            if (Array.isArray(_data["rounds"])) {
                (<any>this).rounds = [] as any;
                for (let item of _data["rounds"])
                    (<any>this).rounds!.push(GameRoundData.fromJS(item));
            }
            else {
                (<any>this).rounds = <any>null;
            }
        }
    }

    static fromJS(data: any): GameDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new GameDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["matchId"] = this.matchId !== undefined ? this.matchId : <any>null;
        data["score"] = this.score ? this.score.toJSON() : <any>null;
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.homePlayers)) {
            data["homePlayers"] = [];
            for (let item of this.homePlayers)
                data["homePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.awayPlayers)) {
            data["awayPlayers"] = [];
            for (let item of this.awayPlayers)
                data["awayPlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGameDataEntity {
    id?: string;
    domainEvents?: IDomainEvent[] | null;
    matchId?: string;
    score?: MapScore;
    players?: GamePlayerData[] | null;
    homePlayers?: GamePlayerData[] | null;
    awayPlayers?: GamePlayerData[] | null;
    rounds?: GameRoundData[] | null;
}

export class GamePlayerData implements IGamePlayerData {
    userId?: IUserId;
    name?: string | null;
    mmr?: number;
    rank?: Rank;
    side?: MatchSide;
    gameTime?: string;
    readonly kills?: number;
    readonly assists?: number;
    readonly deaths?: number;
    readonly damage?: number;
    readonly roundMvps?: number;
    mvp?: boolean;
    readonly aces?: number;
    readonly weapons?: WeaponData[] | null;
    readonly gadgets?: GadgetData[] | null;
    rounds?: GamePlayerRoundData[] | null;

    constructor(data?: IGamePlayerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] ? IUserId.fromJS(_data["userId"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.mmr = _data["mmr"] !== undefined ? _data["mmr"] : <any>null;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : <any>null;
            this.side = _data["side"] !== undefined ? _data["side"] : <any>null;
            this.gameTime = _data["gameTime"] !== undefined ? _data["gameTime"] : <any>null;
            (<any>this).kills = _data["kills"] !== undefined ? _data["kills"] : <any>null;
            (<any>this).assists = _data["assists"] !== undefined ? _data["assists"] : <any>null;
            (<any>this).deaths = _data["deaths"] !== undefined ? _data["deaths"] : <any>null;
            (<any>this).damage = _data["damage"] !== undefined ? _data["damage"] : <any>null;
            (<any>this).roundMvps = _data["roundMvps"] !== undefined ? _data["roundMvps"] : <any>null;
            this.mvp = _data["mvp"] !== undefined ? _data["mvp"] : <any>null;
            (<any>this).aces = _data["aces"] !== undefined ? _data["aces"] : <any>null;
            if (Array.isArray(_data["weapons"])) {
                (<any>this).weapons = [] as any;
                for (let item of _data["weapons"])
                    (<any>this).weapons!.push(WeaponData.fromJS(item));
            }
            else {
                (<any>this).weapons = <any>null;
            }
            if (Array.isArray(_data["gadgets"])) {
                (<any>this).gadgets = [] as any;
                for (let item of _data["gadgets"])
                    (<any>this).gadgets!.push(GadgetData.fromJS(item));
            }
            else {
                (<any>this).gadgets = <any>null;
            }
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(GamePlayerRoundData.fromJS(item));
            }
            else {
                this.rounds = <any>null;
            }
        }
    }

    static fromJS(data: any): GamePlayerData {
        data = typeof data === 'object' ? data : {};
        let result = new GamePlayerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId ? this.userId.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mmr"] = this.mmr !== undefined ? this.mmr : <any>null;
        data["rank"] = this.rank !== undefined ? this.rank : <any>null;
        data["side"] = this.side !== undefined ? this.side : <any>null;
        data["gameTime"] = this.gameTime !== undefined ? this.gameTime : <any>null;
        data["kills"] = this.kills !== undefined ? this.kills : <any>null;
        data["assists"] = this.assists !== undefined ? this.assists : <any>null;
        data["deaths"] = this.deaths !== undefined ? this.deaths : <any>null;
        data["damage"] = this.damage !== undefined ? this.damage : <any>null;
        data["roundMvps"] = this.roundMvps !== undefined ? this.roundMvps : <any>null;
        data["mvp"] = this.mvp !== undefined ? this.mvp : <any>null;
        data["aces"] = this.aces !== undefined ? this.aces : <any>null;
        if (Array.isArray(this.weapons)) {
            data["weapons"] = [];
            for (let item of this.weapons)
                data["weapons"].push(item.toJSON());
        }
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGamePlayerData {
    userId?: IUserId;
    name?: string | null;
    mmr?: number;
    rank?: Rank;
    side?: MatchSide;
    gameTime?: string;
    kills?: number;
    assists?: number;
    deaths?: number;
    damage?: number;
    roundMvps?: number;
    mvp?: boolean;
    aces?: number;
    weapons?: WeaponData[] | null;
    gadgets?: GadgetData[] | null;
    rounds?: GamePlayerRoundData[] | null;
}

export class GamePlayerRoundData implements IGamePlayerRoundData {
    userId?: IUserId;
    name?: string | null;
    roundTime?: string;
    side?: MatchSide;
    roundNumber?: number;
    readonly kills?: number;
    assists?: number;
    died?: boolean;
    readonly damage?: number;
    firstBlood?: boolean;
    mvp?: boolean;
    ace?: boolean;
    won?: boolean;
    weapons?: WeaponData[] | null;
    gadgets?: GadgetData[] | null;

    constructor(data?: IGamePlayerRoundData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] ? IUserId.fromJS(_data["userId"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.roundTime = _data["roundTime"] !== undefined ? _data["roundTime"] : <any>null;
            this.side = _data["side"] !== undefined ? _data["side"] : <any>null;
            this.roundNumber = _data["roundNumber"] !== undefined ? _data["roundNumber"] : <any>null;
            (<any>this).kills = _data["kills"] !== undefined ? _data["kills"] : <any>null;
            this.assists = _data["assists"] !== undefined ? _data["assists"] : <any>null;
            this.died = _data["died"] !== undefined ? _data["died"] : <any>null;
            (<any>this).damage = _data["damage"] !== undefined ? _data["damage"] : <any>null;
            this.firstBlood = _data["firstBlood"] !== undefined ? _data["firstBlood"] : <any>null;
            this.mvp = _data["mvp"] !== undefined ? _data["mvp"] : <any>null;
            this.ace = _data["ace"] !== undefined ? _data["ace"] : <any>null;
            this.won = _data["won"] !== undefined ? _data["won"] : <any>null;
            if (Array.isArray(_data["weapons"])) {
                this.weapons = [] as any;
                for (let item of _data["weapons"])
                    this.weapons!.push(WeaponData.fromJS(item));
            }
            else {
                this.weapons = <any>null;
            }
            if (Array.isArray(_data["gadgets"])) {
                this.gadgets = [] as any;
                for (let item of _data["gadgets"])
                    this.gadgets!.push(GadgetData.fromJS(item));
            }
            else {
                this.gadgets = <any>null;
            }
        }
    }

    static fromJS(data: any): GamePlayerRoundData {
        data = typeof data === 'object' ? data : {};
        let result = new GamePlayerRoundData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId ? this.userId.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["roundTime"] = this.roundTime !== undefined ? this.roundTime : <any>null;
        data["side"] = this.side !== undefined ? this.side : <any>null;
        data["roundNumber"] = this.roundNumber !== undefined ? this.roundNumber : <any>null;
        data["kills"] = this.kills !== undefined ? this.kills : <any>null;
        data["assists"] = this.assists !== undefined ? this.assists : <any>null;
        data["died"] = this.died !== undefined ? this.died : <any>null;
        data["damage"] = this.damage !== undefined ? this.damage : <any>null;
        data["firstBlood"] = this.firstBlood !== undefined ? this.firstBlood : <any>null;
        data["mvp"] = this.mvp !== undefined ? this.mvp : <any>null;
        data["ace"] = this.ace !== undefined ? this.ace : <any>null;
        data["won"] = this.won !== undefined ? this.won : <any>null;
        if (Array.isArray(this.weapons)) {
            data["weapons"] = [];
            for (let item of this.weapons)
                data["weapons"].push(item.toJSON());
        }
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGamePlayerRoundData {
    userId?: IUserId;
    name?: string | null;
    roundTime?: string;
    side?: MatchSide;
    roundNumber?: number;
    kills?: number;
    assists?: number;
    died?: boolean;
    damage?: number;
    firstBlood?: boolean;
    mvp?: boolean;
    ace?: boolean;
    won?: boolean;
    weapons?: WeaponData[] | null;
    gadgets?: GadgetData[] | null;
}

export class GameRoundData implements IGameRoundData {
    readonly roundNumber?: number;
    winner?: MatchSide;
    homeMvp?: IUser;
    awayMvp?: IUser;
    readonly damage?: number;
    readonly kills?: number;
    readonly assists?: number;
    readonly deaths?: number;
    readonly weapons?: WeaponData[] | null;
    readonly gadgets?: GadgetData[] | null;
    players?: GamePlayerRoundData[] | null;

    constructor(data?: IGameRoundData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).roundNumber = _data["roundNumber"] !== undefined ? _data["roundNumber"] : <any>null;
            this.winner = _data["winner"] !== undefined ? _data["winner"] : <any>null;
            this.homeMvp = _data["homeMvp"] ? IUser.fromJS(_data["homeMvp"]) : <any>null;
            this.awayMvp = _data["awayMvp"] ? IUser.fromJS(_data["awayMvp"]) : <any>null;
            (<any>this).damage = _data["damage"] !== undefined ? _data["damage"] : <any>null;
            (<any>this).kills = _data["kills"] !== undefined ? _data["kills"] : <any>null;
            (<any>this).assists = _data["assists"] !== undefined ? _data["assists"] : <any>null;
            (<any>this).deaths = _data["deaths"] !== undefined ? _data["deaths"] : <any>null;
            if (Array.isArray(_data["weapons"])) {
                (<any>this).weapons = [] as any;
                for (let item of _data["weapons"])
                    (<any>this).weapons!.push(WeaponData.fromJS(item));
            }
            else {
                (<any>this).weapons = <any>null;
            }
            if (Array.isArray(_data["gadgets"])) {
                (<any>this).gadgets = [] as any;
                for (let item of _data["gadgets"])
                    (<any>this).gadgets!.push(GadgetData.fromJS(item));
            }
            else {
                (<any>this).gadgets = <any>null;
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(GamePlayerRoundData.fromJS(item));
            }
            else {
                this.players = <any>null;
            }
        }
    }

    static fromJS(data: any): GameRoundData {
        data = typeof data === 'object' ? data : {};
        let result = new GameRoundData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundNumber"] = this.roundNumber !== undefined ? this.roundNumber : <any>null;
        data["winner"] = this.winner !== undefined ? this.winner : <any>null;
        data["homeMvp"] = this.homeMvp ? this.homeMvp.toJSON() : <any>null;
        data["awayMvp"] = this.awayMvp ? this.awayMvp.toJSON() : <any>null;
        data["damage"] = this.damage !== undefined ? this.damage : <any>null;
        data["kills"] = this.kills !== undefined ? this.kills : <any>null;
        data["assists"] = this.assists !== undefined ? this.assists : <any>null;
        data["deaths"] = this.deaths !== undefined ? this.deaths : <any>null;
        if (Array.isArray(this.weapons)) {
            data["weapons"] = [];
            for (let item of this.weapons)
                data["weapons"].push(item.toJSON());
        }
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGameRoundData {
    roundNumber?: number;
    winner?: MatchSide;
    homeMvp?: IUser;
    awayMvp?: IUser;
    damage?: number;
    kills?: number;
    assists?: number;
    deaths?: number;
    weapons?: WeaponData[] | null;
    gadgets?: GadgetData[] | null;
    players?: GamePlayerRoundData[] | null;
}

export class IDomainEvent implements IIDomainEvent {

    constructor(data?: IIDomainEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IDomainEvent {
        data = typeof data === 'object' ? data : {};
        let result = new IDomainEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIDomainEvent {
}

export class IUser implements IIUser {
    userId?: IUserId;
    readonly name?: string | null;

    constructor(data?: IIUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] ? IUserId.fromJS(_data["userId"]) : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): IUser {
        data = typeof data === 'object' ? data : {};
        let result = new IUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId ? this.userId.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IIUser {
    userId?: IUserId;
    name?: string | null;
}

export class IUserId implements IIUserId {

    constructor(data?: IIUserId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IUserId {
        data = typeof data === 'object' ? data : {};
        let result = new IUserId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIUserId {
}

export enum Map {
    Factory = "Factory",
    Skyscraper = "Skyscraper",
    Hideout = "Hideout",
    Ship = "Ship",
    Arctic = "Arctic",
    Dam = "Dam",
    Killhouse = "Killhouse",
    Outpost = "Outpost",
}

export class MapScore implements IMapScore {
    home?: number;
    away?: number;
    outcome?: ScoreOutcome;
    map?: Map;

    constructor(data?: IMapScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.home = _data["home"] !== undefined ? _data["home"] : <any>null;
            this.away = _data["away"] !== undefined ? _data["away"] : <any>null;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : <any>null;
            this.map = _data["map"] !== undefined ? _data["map"] : <any>null;
        }
    }

    static fromJS(data: any): MapScore {
        data = typeof data === 'object' ? data : {};
        let result = new MapScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["home"] = this.home !== undefined ? this.home : <any>null;
        data["away"] = this.away !== undefined ? this.away : <any>null;
        data["outcome"] = this.outcome !== undefined ? this.outcome : <any>null;
        data["map"] = this.map !== undefined ? this.map : <any>null;
        return data;
    }
}

export interface IMapScore {
    home?: number;
    away?: number;
    outcome?: ScoreOutcome;
    map?: Map;
}

export class MatchDataDto implements IMatchDataDto {
    match?: MatchDto;
    gameData?: GameDataEntity[] | null;

    constructor(data?: IMatchDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.match = _data["match"] ? MatchDto.fromJS(_data["match"]) : <any>null;
            if (Array.isArray(_data["gameData"])) {
                this.gameData = [] as any;
                for (let item of _data["gameData"])
                    this.gameData!.push(GameDataEntity.fromJS(item));
            }
            else {
                this.gameData = <any>null;
            }
        }
    }

    static fromJS(data: any): MatchDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match ? this.match.toJSON() : <any>null;
        if (Array.isArray(this.gameData)) {
            data["gameData"] = [];
            for (let item of this.gameData)
                data["gameData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchDataDto {
    match?: MatchDto;
    gameData?: GameDataEntity[] | null;
}

export class MatchDto implements IMatchDto {
    id?: string;
    matchNumber?: number;
    status?: MatchStatus;
    readonly homePlayers?: MatchPlayerDto[] | null;
    readonly homeMMR?: number;
    readonly awayPlayers?: MatchPlayerDto[] | null;
    readonly awayMMR?: number;
    allPlayers?: MatchPlayerDto[] | null;
    hostPlayer?: MatchPlayerDto;
    score?: MatchScore;

    constructor(data?: IMatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.matchNumber = _data["matchNumber"] !== undefined ? _data["matchNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["homePlayers"])) {
                (<any>this).homePlayers = [] as any;
                for (let item of _data["homePlayers"])
                    (<any>this).homePlayers!.push(MatchPlayerDto.fromJS(item));
            }
            else {
                (<any>this).homePlayers = <any>null;
            }
            (<any>this).homeMMR = _data["homeMMR"] !== undefined ? _data["homeMMR"] : <any>null;
            if (Array.isArray(_data["awayPlayers"])) {
                (<any>this).awayPlayers = [] as any;
                for (let item of _data["awayPlayers"])
                    (<any>this).awayPlayers!.push(MatchPlayerDto.fromJS(item));
            }
            else {
                (<any>this).awayPlayers = <any>null;
            }
            (<any>this).awayMMR = _data["awayMMR"] !== undefined ? _data["awayMMR"] : <any>null;
            if (Array.isArray(_data["allPlayers"])) {
                this.allPlayers = [] as any;
                for (let item of _data["allPlayers"])
                    this.allPlayers!.push(MatchPlayerDto.fromJS(item));
            }
            else {
                this.allPlayers = <any>null;
            }
            this.hostPlayer = _data["hostPlayer"] ? MatchPlayerDto.fromJS(_data["hostPlayer"]) : <any>null;
            this.score = _data["score"] ? MatchScore.fromJS(_data["score"]) : <any>null;
        }
    }

    static fromJS(data: any): MatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["matchNumber"] = this.matchNumber !== undefined ? this.matchNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.homePlayers)) {
            data["homePlayers"] = [];
            for (let item of this.homePlayers)
                data["homePlayers"].push(item.toJSON());
        }
        data["homeMMR"] = this.homeMMR !== undefined ? this.homeMMR : <any>null;
        if (Array.isArray(this.awayPlayers)) {
            data["awayPlayers"] = [];
            for (let item of this.awayPlayers)
                data["awayPlayers"].push(item.toJSON());
        }
        data["awayMMR"] = this.awayMMR !== undefined ? this.awayMMR : <any>null;
        if (Array.isArray(this.allPlayers)) {
            data["allPlayers"] = [];
            for (let item of this.allPlayers)
                data["allPlayers"].push(item.toJSON());
        }
        data["hostPlayer"] = this.hostPlayer ? this.hostPlayer.toJSON() : <any>null;
        data["score"] = this.score ? this.score.toJSON() : <any>null;
        return data;
    }
}

export interface IMatchDto {
    id?: string;
    matchNumber?: number;
    status?: MatchStatus;
    homePlayers?: MatchPlayerDto[] | null;
    homeMMR?: number;
    awayPlayers?: MatchPlayerDto[] | null;
    awayMMR?: number;
    allPlayers?: MatchPlayerDto[] | null;
    hostPlayer?: MatchPlayerDto;
    score?: MatchScore;
}

export class MatchPlayerDto implements IMatchPlayerDto {
    readonly userId?: number;
    readonly name?: string | null;
    readonly mmr?: number;
    rank?: Rank;
    side?: MatchSide;
    readonly confirmed?: boolean;
    readonly isHost?: boolean;

    constructor(data?: IMatchPlayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).mmr = _data["mmr"] !== undefined ? _data["mmr"] : <any>null;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : <any>null;
            this.side = _data["side"] !== undefined ? _data["side"] : <any>null;
            (<any>this).confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            (<any>this).isHost = _data["isHost"] !== undefined ? _data["isHost"] : <any>null;
        }
    }

    static fromJS(data: any): MatchPlayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPlayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mmr"] = this.mmr !== undefined ? this.mmr : <any>null;
        data["rank"] = this.rank !== undefined ? this.rank : <any>null;
        data["side"] = this.side !== undefined ? this.side : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["isHost"] = this.isHost !== undefined ? this.isHost : <any>null;
        return data;
    }
}

export interface IMatchPlayerDto {
    userId?: number;
    name?: string | null;
    mmr?: number;
    rank?: Rank;
    side?: MatchSide;
    confirmed?: boolean;
    isHost?: boolean;
}

export class MatchScore implements IMatchScore {
    readonly maps?: MapScore[] | null;
    roundScore?: Score;
    mapScore?: Score;
    outcome?: ScoreOutcome;

    constructor(data?: IMatchScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["maps"])) {
                (<any>this).maps = [] as any;
                for (let item of _data["maps"])
                    (<any>this).maps!.push(MapScore.fromJS(item));
            }
            else {
                (<any>this).maps = <any>null;
            }
            this.roundScore = _data["roundScore"] ? Score.fromJS(_data["roundScore"]) : <any>null;
            this.mapScore = _data["mapScore"] ? Score.fromJS(_data["mapScore"]) : <any>null;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : <any>null;
        }
    }

    static fromJS(data: any): MatchScore {
        data = typeof data === 'object' ? data : {};
        let result = new MatchScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maps)) {
            data["maps"] = [];
            for (let item of this.maps)
                data["maps"].push(item.toJSON());
        }
        data["roundScore"] = this.roundScore ? this.roundScore.toJSON() : <any>null;
        data["mapScore"] = this.mapScore ? this.mapScore.toJSON() : <any>null;
        data["outcome"] = this.outcome !== undefined ? this.outcome : <any>null;
        return data;
    }
}

export interface IMatchScore {
    maps?: MapScore[] | null;
    roundScore?: Score;
    mapScore?: Score;
    outcome?: ScoreOutcome;
}

export enum MatchSide {
    Home = "Home",
    Away = "Away",
}

export enum MatchStatus {
    PendingConfirmation = "PendingConfirmation",
    Confirmed = "Confirmed",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum Rank {
    Copper = "Copper",
    Bronze = "Bronze",
    Silver = "Silver",
    Gold = "Gold",
    Diamond = "Diamond",
}

export class Score implements IScore {
    home?: number;
    away?: number;
    outcome?: ScoreOutcome;

    constructor(data?: IScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.home = _data["home"] !== undefined ? _data["home"] : <any>null;
            this.away = _data["away"] !== undefined ? _data["away"] : <any>null;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : <any>null;
        }
    }

    static fromJS(data: any): Score {
        data = typeof data === 'object' ? data : {};
        let result = new Score();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["home"] = this.home !== undefined ? this.home : <any>null;
        data["away"] = this.away !== undefined ? this.away : <any>null;
        data["outcome"] = this.outcome !== undefined ? this.outcome : <any>null;
        return data;
    }
}

export interface IScore {
    home?: number;
    away?: number;
    outcome?: ScoreOutcome;
}

export enum ScoreOutcome {
    Home = "Home",
    Away = "Away",
    Draw = "Draw",
}

export class WeaponData implements IWeaponData {
    type?: WeaponType;
    kills?: number;
    headshotKills?: number;
    shotsFired?: number;
    hits?: number;
    headshots?: number;
    damage?: number;
    friendlyDamage?: number;

    constructor(data?: IWeaponData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.kills = _data["kills"] !== undefined ? _data["kills"] : <any>null;
            this.headshotKills = _data["headshotKills"] !== undefined ? _data["headshotKills"] : <any>null;
            this.shotsFired = _data["shotsFired"] !== undefined ? _data["shotsFired"] : <any>null;
            this.hits = _data["hits"] !== undefined ? _data["hits"] : <any>null;
            this.headshots = _data["headshots"] !== undefined ? _data["headshots"] : <any>null;
            this.damage = _data["damage"] !== undefined ? _data["damage"] : <any>null;
            this.friendlyDamage = _data["friendlyDamage"] !== undefined ? _data["friendlyDamage"] : <any>null;
        }
    }

    static fromJS(data: any): WeaponData {
        data = typeof data === 'object' ? data : {};
        let result = new WeaponData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["kills"] = this.kills !== undefined ? this.kills : <any>null;
        data["headshotKills"] = this.headshotKills !== undefined ? this.headshotKills : <any>null;
        data["shotsFired"] = this.shotsFired !== undefined ? this.shotsFired : <any>null;
        data["hits"] = this.hits !== undefined ? this.hits : <any>null;
        data["headshots"] = this.headshots !== undefined ? this.headshots : <any>null;
        data["damage"] = this.damage !== undefined ? this.damage : <any>null;
        data["friendlyDamage"] = this.friendlyDamage !== undefined ? this.friendlyDamage : <any>null;
        return data;
    }
}

export interface IWeaponData {
    type?: WeaponType;
    kills?: number;
    headshotKills?: number;
    shotsFired?: number;
    hits?: number;
    headshots?: number;
    damage?: number;
    friendlyDamage?: number;
}

export enum WeaponType {
    Jesper = "Jesper",
    Spectral = "Spectral",
    Cyclone = "Cyclone",
    Taurus = "Taurus",
    Omen = "Omen",
    Viper = "Viper",
    RCP = "RCP",
    Cadillo = "Cadillo",
    Auril = "Auril",
    Vezin = "Vezin",
    Marui = "Marui",
    Canutt = "Canutt",
    Urakan = "Urakan",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}